import { render, staticRenderFns } from "./TranslateTree.vue?vue&type=template&id=5e865efc&scoped=true&"
import script from "./TranslateTree.vue?vue&type=script&lang=js&"
export * from "./TranslateTree.vue?vue&type=script&lang=js&"
import style0 from "./TranslateTree.vue?vue&type=style&index=0&id=5e865efc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e865efc",
  null
  
)

export default component.exports